var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLine53 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 949,
  height: 2,
  viewBox: "0 0 949 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  y1: 1,
  x2: 1334,
  y2: 1,
  stroke: "#D0D9DF",
  strokeWidth: 2
})));
export { SvgLine53 as ReactComponent };
export default __webpack_public_path__ + "bd2549378fac255355eb3bbc1ca093a4.svg";